var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollaboratorSignatureMutual(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 140,
    viewBox: "0 0 109 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.682 0.117676H0.59082V140H108.682V0.117676Z",
    fill: "#F8F9FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5667 117.553H59.5972V125.114H99.5667V117.553Z",
    fill: "#E0F5EA",
    stroke: "#007F40",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5669 106.84H69.7083V114.402H99.5669V106.84Z",
    fill: "#E1F3FB",
    stroke: "#0166AA",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1804 37.9233H99.4876",
    stroke: "#8A8F99",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43774 100.303H67.5752",
    stroke: "#8A8F99",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43774 71.9492H48.6174",
    stroke: "#8A8F99",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43774 43.5952H99.8036",
    stroke: "#8A8F99",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3604 83.2915H99.8038",
    stroke: "#8A8F99",
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43774 49.2656H99.8036",
    stroke: "#8A8F99",
    strokeWidth: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43774 88.9614H99.8036",
    stroke: "#8A8F99",
    strokeWidth: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43774 54.9375H99.8036",
    stroke: "#8A8F99",
    strokeWidth: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43774 94.6333H99.8036",
    stroke: "#8A8F99",
    strokeWidth: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43774 60.6074H99.8036",
    stroke: "#8A8F99",
    strokeWidth: 0.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1804 35.4028H99.4876",
    stroke: "#E8EAEF",
    strokeWidth: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43774 97.7832H67.5752",
    stroke: "#E8EAEF",
    strokeWidth: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43774 66.2783H99.8036",
    stroke: "#8A8F99",
    strokeWidth: 0.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43774 70.0591H48.6174",
    stroke: "#E8EAEF",
    strokeWidth: 0.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43774 46.7451H99.8036",
    stroke: "#E8EAEF",
    strokeWidth: 0.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43774 86.4414H99.8036",
    stroke: "#E8EAEF",
    strokeWidth: 0.5
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43774 41.0747H99.8036",
    stroke: "#E8EAEF",
    strokeWidth: 0.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3604 80.771H99.8038",
    stroke: "#E8EAEF",
    strokeWidth: 0.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43774 58.0864H99.8036",
    stroke: "#E8EAEF",
    strokeWidth: 0.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43774 52.4165H99.8036",
    stroke: "#E8EAEF",
    strokeWidth: 0.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43774 92.1123H99.8036",
    stroke: "#E8EAEF",
    strokeWidth: 0.5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43774 63.7583H99.8036",
    stroke: "#E8EAEF",
    strokeWidth: 0.5
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5269 112.666C74.7967 112.647 75.085 112.521 75.3245 112.419C76.9082 111.747 78.4061 110.872 79.5208 109.541C79.7913 109.218 80.4527 108.18 80.352 108.589C80.2769 108.894 80.0503 109.179 79.8861 109.438C79.2893 110.38 78.8763 111.394 78.522 112.446C78.496 112.523 78.3011 112.893 78.3377 112.984C78.3466 113.006 78.3834 112.966 78.4013 112.95C78.5903 112.783 78.7666 112.589 78.9443 112.412C80.0688 111.291 81.1675 110.143 82.316 109.047C82.4137 108.954 82.6514 108.675 82.6445 108.81C82.6259 109.171 82.3371 109.587 82.1887 109.902C81.9172 110.479 81.5991 111.055 81.3575 111.644C81.2955 111.795 81.5798 111.764 81.6457 111.764C82.0879 111.764 82.4841 111.597 82.8758 111.406C82.9815 111.355 83.3861 111.045 83.3852 111.045C83.1314 111.088 82.9282 111.322 82.7585 111.497C82.5751 111.685 82.5858 111.508 82.5641 111.269C82.547 111.082 82.5678 110.459 82.9093 110.721C83.0371 110.819 84.1589 111.836 83.7539 111.998C83.4273 112.128 82.9699 112.069 82.6311 112.058C82.0941 112.04 81.2551 112.011 80.8547 111.577C80.5521 111.248 83.2439 111.073 83.2947 111.072C85.9039 111.008 88.4857 111.52 91.0571 111.884",
    stroke: "#0166AA",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8879 122.328C63.0157 121.502 64.1767 120.741 65.1614 119.738C65.4551 119.439 65.7553 119.116 65.9668 118.751C65.9991 118.695 66.1133 118.571 66.049 118.576C65.9541 118.585 65.799 118.734 65.7351 118.788C65.4362 119.038 65.1938 119.344 65.0228 119.695C64.7057 120.345 64.6634 121.036 64.7024 121.745C64.7391 122.412 64.5948 122.961 64.0313 123.39C63.5522 123.755 62.9501 123.72 62.8795 123.049C62.7922 122.22 63.751 121.973 64.4036 121.979C64.7642 121.981 65.114 122.125 65.4688 122.037C65.7801 121.959 65.9204 121.766 66.1356 121.551C66.1932 121.494 66.6352 121.163 66.3521 121.357C66.0285 121.578 65.678 121.8 65.4688 122.138C65.4625 122.149 65.317 122.441 65.419 122.369C65.7949 122.104 66.0447 121.635 66.3261 121.279C66.4814 121.083 66.3715 121.594 66.3694 121.676C66.366 121.812 66.2207 122.344 66.4322 122.326C67.0338 122.274 67.9063 120.445 67.6533 120.992C67.5082 121.305 67.312 121.594 67.151 121.899C67.1128 121.971 66.854 122.371 67.0363 122.177C67.2495 121.951 67.7332 121.555 68.0776 121.555C68.2078 121.555 67.8258 121.767 67.7918 121.782C67.715 121.816 67.6111 121.848 67.5255 121.845C67.4916 121.843 67.4909 121.789 67.5212 121.789C67.5843 121.789 67.6602 121.953 67.6944 121.991C67.7846 122.094 67.8943 122.152 68.0321 122.117C68.3615 122.033 68.6251 121.739 68.857 121.512C69.075 121.299 69.2809 121.078 69.4697 120.839C69.6487 120.612 69.3192 121.087 69.2965 121.119C69.0983 121.4 68.9071 121.682 68.7293 121.976C68.6328 122.136 68.4727 122.327 68.4132 122.505C68.3751 122.619 68.5904 122.341 68.6903 122.274C68.816 122.19 68.9891 122.099 69.1471 122.099C69.2013 122.099 69.1718 122.289 69.1774 122.328C69.2137 122.581 70.1268 122.016 70.2339 121.946C70.5448 121.743 70.5086 121.785 70.366 122.076C70.2586 122.295 70.3232 122.33 70.5695 122.376C71.2582 122.503 71.9747 122.554 72.6695 122.613C74.9057 122.802 77.1464 122.917 79.3853 123.066",
    stroke: "#007F40",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6558 121.358C70.6558 121.249 70.7593 121.119 70.8138 121.027C71.0478 120.634 71.2731 120.214 71.591 119.881C71.7615 119.702 71.884 119.624 72.1171 119.553C72.2874 119.501 72.3959 119.517 72.3618 119.704C72.2624 120.249 71.9969 120.786 71.7642 121.282C71.6445 121.537 71.519 121.79 71.4048 122.048C71.402 122.055 71.3231 122.261 71.2879 122.195C71.111 121.862 71.506 121.171 71.7469 120.978C72.0426 120.74 72.3407 121.129 72.6779 121.021C72.9566 120.931 73.3037 120.658 73.4378 120.39C73.5195 120.227 73.3525 120.589 73.336 120.628C73.2819 120.756 72.7964 122.24 72.9939 122.251C73.8623 122.299 73.103 121.366 73.9716 121.366",
    stroke: "#007F40",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5337 21.147H9.67505V28.7082H39.5337V21.147Z",
    fill: "#E1F3FB",
    stroke: "#0166AA",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6174 75.731H9.43774V83.2922H48.6174V75.731Z",
    fill: "#E1F3FB",
    stroke: "#0166AA",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollaboratorSignatureMutual);
export default __webpack_public_path__ + "static/media/collaborator-signature-mutual.2efd2fc8ecd88cf6ab66105905e9b2d9.svg";
export { ForwardRef as ReactComponent };